import { render, staticRenderFns } from "./OddsInfo.vue?vue&type=template&id=5d4d4ec8"
import script from "./OddsInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./OddsInfo.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports